function SuperCompaniesPage() {
    return ( <h1>SuperCompanies Page</h1> );
}

export default SuperCompaniesPage;